import { 
  Container, 
  Typography, 
  Paper } 
from "@mui/material";

const CoverageSelectorHeader = () => {
  return (
    <Container maxWidth="md" disableGutters={{ xs: true, md: false }}>
        <Paper elevation={0} sx={{ p: { md: 2 }, mb: { xs: 2, md: 2 } }}>
            <Typography variant="h6"
                sx ={{ 
                    fontWeight: "bold", 
                    color: "text.primary",
                    mb: { xs: 6, md: 4 }
                }}
                >
                ELIJA LA SOLUCION QUE MEJOR SE ADAPTE A SUS NECESIDADES
            </Typography>
        </Paper>
    </Container>
  );
};

export default CoverageSelectorHeader